import API from "../../api/api";

const state = () => ({
  mediacontacts: [],
  loading: false,
});

const mutations = {
  getMediaContacts(state, payload) {
    state.mediacontacts = payload;
  },
  isLoading(state, payload) {
    state.loading = payload;
  },
};

const actions = {
  async fetchMediaContacts({ commit }) {
    await API.get("media-contact")
      .then(res => {
        commit("getMediaContacts", res.data.data);
      })
      .catch(err => {
        console.log("ERROR", err);
      });
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
